import React from 'react';
import './ResInfo.scss';
import {observer, inject,} from 'mobx-react';
import showResponseInJsonFormat from '../../assets/js/JsonFormat';
import showResponseInXMLFormat from '../../assets/js/xmlFormat';

const ResInfo = inject("mainStore", "AllInputsStore")(observer((props) => {
  const store = props.mainStore;
  const inputs = props.AllInputsStore.inputs;
  const res = store.response;
  const err = store.error;

  const getStatusCode = (res, err) => {
    if(res)  return 200;
    if(!err) return '';
    if(!err.response) return '';
    if(err.response.data.errors && err.response.data.errors[0].status) {
      return err.response.data.errors[0].status;
    }
    return err.response.status;
  };

  const getData = (res, err) => {
    let data = null;
    if (res) {
      data = res.data;
    } else if (err && err.response) {
      data = err.response.data;
    }
    return data;
  };

  const renderJSONData = (data) => {
    if (res) {
      return <div dangerouslySetInnerHTML={{__html: showResponseInJsonFormat(data)}}></div>;
    } else if (err && err.response && err.response.data.errors) {
      return <pre>{JSON.stringify(data, null, ' ')}</pre>
    } else if(err && err.response) {
      return <div dangerouslySetInnerHTML={{__html: data}}></div>;
    } else {
      return <p>Unknown Error</p>
    }
  };

  const renderXMLData = (data) => {
    if (res) {
      return <div dangerouslySetInnerHTML={{__html: showResponseInXMLFormat(data)}}></div>;
    } else if (err && err.response && err.response.data.errors) {
      return <pre>{JSON.stringify(data, null, ' ')}</pre>
    } else if(err && err.response) {
      return <div dangerouslySetInnerHTML={{__html: showResponseInXMLFormat(data)}}></div>;
      return <p>{err.response.data}</p>
    } else {
      return <p>Unknown Error</p>
    }
  }

  const renderResponseData = () => {
    const format = inputs['accept'].value;
    const data = getData(res, err);
    if (format === 'json') {
      return renderJSONData(data);
    } else {
      return renderXMLData(data);
    }
  };

  const isSuccessResponse = () => {
    const status = getStatusCode(res, err);
    if(status !== 200) return false;
    const data = getData(res, err);
    if(!data || data.error) return false;
    return true;
  };

  const getResponseInfoClass = () => {
    const baseClassName = 'res-info';
    const responseInfoClass = isSuccessResponse() ? `${baseClassName} ${baseClassName}_success` : `${baseClassName} ${baseClassName}_fail`;
    return responseInfoClass
  };

  const renderResponseStatusText = () => {
    const successResponseResultText = 'Successful Request';
    const failResponseResultText = 'Unsuccessful Request';
    const responseText = isSuccessResponse() ? successResponseResultText : failResponseResultText;
    const responseResultBaseClass = 'res-info__result';
    return <span className={responseResultBaseClass}>[{responseText}]</span>
  }

  const renderHeader = () => {
    return (
        <div className="res-info__header">
          <h3 className="res-info__title">Response</h3>
          {renderResponseStatusText()}
        </div>
    );
  }

  const renderContent = () => {
    return (
        <div className="res-info__content">
          {renderResponseData()}
        </div>
    )
  };


  return (
      <div className={getResponseInfoClass()}>
        {renderHeader()}
        {renderContent()}
      </div>
  );
}));

export default ResInfo;
